module.exports = __webpack_public_path__ + "static/media/appStore.63f0d2d9.png";